module.exports = __webpack_public_path__ + "static/img/zd03.0a7ddde3.svg";